export const replaceUnderscores = (word: string): string => word && word.replace(/_/g, " ");
